import store from "../store";
import {WizardItem} from "../interfaces/Wizard";
import {AVAILABLE_VISUALIZER_TYPES} from "../config";

const UNAV_SUPPORTED_VISUALIZERS = [
  AVAILABLE_VISUALIZER_TYPES.bvLook,
  // AVAILABLE_VISUALIZER_TYPES.kvScene,
  // AVAILABLE_VISUALIZER_TYPES.Fireplace,
  // AVAILABLE_VISUALIZER_TYPES.LaundryRoom,
];

const USE_NEW_NAV_URL = window.location.href.includes("useNewNav=1");

/**
 * Is the unified navigation (UNav, PartCommon.getUNavigationItems) on for this request?
 * Only for UNAV_SUPPORTED_VISUALIZERS, and then:
 * QCDES-9099, TEMPORARY (testing): the active wizard item's `showNotCompatibleProducts` property turns it on for
 *    materials wizard requests. Remove this part once it's not needed anymore.
 *
 * @param visualizerType - layout.visualizerType of the feature group
 * @param forWizardGroup - the navigation is requested for a materials wizard group (the wizard item flag only applies there)
 * @param wizardActiveItem - pass it when the caller already has it (e.g. restOptions), otherwise it's taken
 * from `wizardState.wizardActiveItem`
 */
export const isNewNavEnabled = (visualizerType: string = document.kvConfig.visualizerType,
                                forWizardGroup = true,
                                wizardActiveItem?: WizardItem | null): boolean => {
  if (!UNAV_SUPPORTED_VISUALIZERS.includes(visualizerType)) {
    return false
  }
  if (!forWizardGroup) {
    return false
  }
  // if (hardCodeIsAmericanStandard()) {
  //   return false
  // }
  if (USE_NEW_NAV_URL) {
    return true
  }
  const activeItem = wizardActiveItem !== undefined ? wizardActiveItem : store.getState().wizardState?.wizardActiveItem;
  return !!activeItem?.showNotCompatibleProducts // ?useNewNav=1, or (QCDES-9099) the active wizard item has showNotCompatibleProducts
};
